import { getIntegrationConnectionStatus } from 'src/clients';
import { useCheckMAMViewOnlyChildType } from 'src/hooks';
import { CONNECTION_STATUS_URL } from 'src/models';
import { reportFunctionError } from 'src/utilities/sentry';
import useSWR from 'swr';

export const useIntegrationConnectionStatus = () => {
  const { isViewOnlyChildActive } = useCheckMAMViewOnlyChildType();
  const { data, ...swr } = useSWR(
    isViewOnlyChildActive ? null : CONNECTION_STATUS_URL,
    () =>
      getIntegrationConnectionStatus().catch(exception => {
        reportFunctionError({
          domain: 'dashboard',
          message: 'Failed to get integration connection status',
          name: 'getIntegrationConnectionStatus',
          exception,
        });
      }),
    {
      revalidateOnMount: true,
      revalidateIfStale: false,
      revalidateOnFocus: false,
    },
  );

  const connectedTo = data?.data.data?.platform ?? null;

  return { connectedTo, ...swr };
};
